/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import ListItem from './ListItem';
import IconMenu from '../common/IconMenu';
import { COLORS } from '../../constants/styles';
import styles from './index.styl';

const ActionItem = ({ index, intro, item, menu, onClick }) => (
  <div className="circle-action-item-card" styleName="circle-member-wrap">
    <If condition={menu && menu.length}>
      <IconMenu
        position={{ vertical: 'bottom', horizontal: 'left' }}
        items={menu}
        icon={{ color: COLORS.bluePrimary }}
        style={{
          position: 'absolute',
          top: '2px',
          right: '10px',
        }}
        allScreens
      />
      <If condition={index === 0 && intro}>
        <span styleName="menu-circle-member" className={intro} />
      </If>
    </If>
    <ListItem {...item} {...{ onClick }} />
  </div>
);

ActionItem.propTypes = {
  index: PropTypes.number,
  intro: PropTypes.string,
  item: PropTypes.shape({
    icon: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    note: PropTypes.string,
  }),
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
      icon: PropTypes.string,
    }),
  ).isRequired,
  onClick: PropTypes.func,
};

ActionItem.defaultProps = {
  onClick: () => {},
};

export default CSSModules(ActionItem, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/CircleList/ActionItem.jsx